import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionDenied, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';

import ROUTES from '../../../routes';

import cn from './styles.module.css';

const ApplicationSchemes = () => {
  const match = useMatch(ROUTES.APPLICATIONS);

  const navigate = useNavigate();

  const { activePermissions } = useAppSelector(
    (state) => state.administrationDictionaries,
  );

  useEffect(() => {
    if (
      match &&
      activePermissions &&
      activePermissions?.includes(PermissionEnum.APPLICATIONS_SCHEMES_LIST)
    ) {
      navigate(ROUTES.APPLICATIONS_LIST);
    }
  }, [match, activePermissions]);

  let content;

  if (activePermissions?.includes(PermissionEnum.APPLICATIONS_SCHEMES_LIST)) {
    content = (
      <div className={cn.applicationsSchemesContent}>
        <div className={cn.settingsTitle}>Application Settings</div>
        <div className={cn.applicationsSchemesWrapper}>
          <Outlet />
        </div>
      </div>
    );
  } else {
    content = <PermissionDenied />;
  }

  return content;
};

export default ApplicationSchemes;
